// removed by extract-text-webpack-plugin
module.exports = {"tabsView":"tabsView___nCMvX","itemView":"itemView___38JDw","bottomLine":"bottomLine___3M14P","bottomContent":"bottomContent___2_onY","am-tabs-pane-wrap":"am-tabs-pane-wrap___1LWyu","childrenView":"childrenView___1QZjq","homeTabs-tab-bar-wrap":"homeTabs-tab-bar-wrap___1XigS","am-tabs-default-bar":"am-tabs-default-bar___RGPzR","am-tabs-tab-bar-wrap":"am-tabs-tab-bar-wrap___3IG62","am-tabs":"am-tabs___1U-Fk","am-tabs-default-bar-tab":"am-tabs-default-bar-tab___2t03B","am-flexbox":"am-flexbox___3CaZs","am-flexbox-wrap":"am-flexbox-wrap___9NSFS"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Shop/Home/ShopHome/components/Tabs/index.modules.less
// module id = 732
// module chunks = 431